/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// page
import Page from 'material/structure/page/page';
// group
import Group from 'material/group/group';
// copy
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import BodyCopy from 'material/copy/bodycopy/bodycopy';
// ctas
import CTAs from 'material/ctas/ctas';
import Button from 'material/ctas/button/button_container';
import Link from 'material/ctas/link/link_container';
import SignUpCTA from 'material/ctas/signup/signup';
// fields
import Form from 'material/form/form_container';
import Field from 'material/form/field/field_container';
// grid
import Grid from 'material/grid/grid';
import GridSet from 'material/grid/gridset/gridset';
import GridItem from 'material/grid/griditem/griditem';
// graphics
import Divider from 'material/graphic/divider/divider';
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/auth/signin/signin_styles';
import { url } from 'utils/urls';


/* ========== ~~~~~~~~~~ PAGE : SIGN IN : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class SignInPage extends Component {
    constructor(props){
        super(props);
        this.formName = 'signin';
    }
    handleSignIn = (currentFields = this.props.fields) =>{
        // this.props.signIn;
        this.props.signIn(currentFields, this.getFormCallData(), this.handleSucessSignIn, this.handleFailedSignIn)
    };
    handleGoogleAuth = () => {
        window.open(url.auth.googleAuth, '_self')
    };

    handleSucessSignIn = (response) => {
        this.props.setAuthData(response);
        this.props.getAllSites(response.data.account_uuid);
        this.props.discardChanges(this.formName);
        // After user is sign in they will be navigated to dashboard/home by Redirect in Router on authState update
        // By calling updatePageDetails we ensure the application state receives new page data.
        // Router will not be setting this data.
        this.props.updatePageDetails('dashboard/home');
    };

    handleFailedSignIn = (response) => {
        const errMessage = !!response && !!response.staus && response.status === 401 ?
            `Woops, email or password is incorrect' : 'Woops, something wrong: Incorrect login or password.` :
            `Woops, email or password is incorrect' : 'Woops, something wrong: Network error. Please try again later.`;
        this.props.displayErrorMessage(errMessage);
        //Remove password and reset its validation state
        this.props.setFormFieldValue(this.formName, 'signinpassword', '');
        this.props.setFieldValidation(this.formName, 'signinpassword', null);
    };

    getFormCallData = () =>({
        email: this.props.fields.email.value,
        password: this.props.fields.signinpassword.value
    });

    fieldHandleKeyDown = (event, isValid) => {
        if (event.key === 'Enter'){
            event.preventDefault();
            return this.handleSignIn(Object.assign({}, this.props.fields, { [event.target.name]: { value: event.target.value, valid: isValid } }));
        }
    }

    render() {
        const { email, signinpassword } = this.props.fields;
        return(
            <Page name={`signin`} klass={this.props.classes.signin}>
                <Group name={`main`}>
                    <Copy>
                        <Title>
                            <h2>Sign In</h2>
                        </Title>
                        <BodyCopy>
                            <p>Sign in to access the Insticator Dashboard</p>
                        </BodyCopy>
                    </Copy>
                    <Form name={this.formName}>
                        <Grid type={`fields`}>
                            <GridSet direction={`vertical`}>
                                <GridItem><Field type={`email`} name={`email`} value={email.value} valid={email.valid} formName={this.formName} placeholder={`Email`} label={`Email Address`} info={``} handleKeyDown={this.fieldHandleKeyDown} required /></GridItem>
                                <GridItem><Field type={`password`} name={`signinpassword`} value={signinpassword.value} valid={signinpassword.valid} formName={this.formName} placeholder={`Password`} label={`Password`} info={``} handleKeyDown={this.fieldHandleKeyDown} required /></GridItem>
                            </GridSet>
                            <GridSet direction={`horizontal`} name={`helpers`}>
                                <GridItem></GridItem>
                                <GridItem type={'full'}><Link type={`internal`} color={`primary`} action={`auth/resetpassword`} variant={`action`} name={`modal`} text={`Forgot your password?`} /></GridItem>
                            </GridSet>
                        </Grid>
                        <CTAs direction={`vertical`}>
                            <Button type={'action'} action={this.handleSignIn} variant={`primary`} name={`login`} text={`Log in`} />
                            <Divider />
                            <Button type={'action'} action={this.handleGoogleAuth} name={`signingoogle`} text={`Log in with Google`} icon={<Icon name={`google`} style={`fab`} />} iconRight />
                            <br/>
                        </CTAs>
                    </Form>
                </Group>
                <Group name={`callout`}>
                    <SignUpCTA />
                </Group>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(SignInPage);
